import * as Yup from 'yup'
export const Schema = Yup.object().shape({
    amount: Yup.string().required('مبلغ واریزی الزامی می باشد'),
})
